declare const jQuery: any;
const $ = jQuery;

const KEY_PREFIX = "iw_volatile_ls_";

export function setLocalStorage(key: string, data: any, lifetimeSecs?: number): void
{
	if (!window.localStorage)
	{
		return;
	}
	const value: string = JSON.stringify({
		data,
		expiry: lifetimeSecs ? Date.now() + lifetimeSecs * 1000 : undefined,
	});
	window.localStorage.setItem(KEY_PREFIX + key, value);
}

export function getLocalStorage(key: string): any
{
	if (!window.localStorage)
	{
		return;
	}
	const valueJSON: string = window.localStorage.getItem(KEY_PREFIX + key);
	if (!valueJSON)
	{
		return undefined;
	}
	const value = JSON.parse(valueJSON);
	const expiry: number = value.expiry;
	if (expiry && (expiry < Date.now()))
	{
		window.localStorage.removeItem(KEY_PREFIX + key);
		return undefined;
	}
	return value.data;
}

function removeLocalStorage(key: string): void
{
	if (!window.localStorage)
	{
		return;
	}
	window.localStorage.removeItem(KEY_PREFIX + key);
}

if (!window["iw"])
{
	window["iw"] = {};
}
if (!window["iw"].utils)
{
	window["iw"].utils = {};
}

window["iw"].utils.setLocalStorage = setLocalStorage;
window["iw"].utils.getLocalStorage = getLocalStorage;
window["iw"].utils.removeLocalStorage = removeLocalStorage;
